import { guessKind } from "components/common/embedCode";

// Tipo della carta salvato nel backend: "food" (Food Cards) o "drinks" (Drinks Cards).
// Le risposte vecchie senza tipo ricadono sulla regola del nome usata finora.
export const isFoodCard = (card) => (card?.kind ? card.kind === "food" : guessKind(card?.name) === "menu");
export const cardType = (card) => (isFoodCard(card) ? "menu" : "drinks");

// Tipo di stile della pagina pubblica: "menu" per le Food Cards; per le Drinks Cards dal nome (vino se non si capisce).
export const styleKind = (card) => {
  if (isFoodCard(card)) return "menu";
  const kind = guessKind(card?.name);
  return kind === "menu" ? "wine" : kind;
};

// Traduzione con i testi da cucina (piatti, menu) per le Food Cards: chiavi in cards:food.*, altrimenti quelle normali.
export const kindT = (t, i18n, food) => (key, options) =>
  food && i18n.exists(`cards:food.${key}`, options) ? t(`food.${key}`, options) : t(key, options);
